"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivationCodeStatusType = void 0;
/**
 * 激活码状态 - unused|未使用 used|已使用 expired|已过期 present|已送出 mismatch|不匹配 usedCountLimit|超出链接可兑换人数 singleUserUsedCountLimit|超出单用户领取次数限制
 */
var ActivationCodeStatusType;
(function (ActivationCodeStatusType) {
    ActivationCodeStatusType["UNUSED"] = "unused";
    ActivationCodeStatusType["USED"] = "used";
    ActivationCodeStatusType["EXPIRED"] = "expired";
    ActivationCodeStatusType["PRESENT"] = "present";
    ActivationCodeStatusType["MISMATCH"] = "mismatch";
    ActivationCodeStatusType["USED_COUNT_LIMIT"] = "usedCountLimit";
    ActivationCodeStatusType["SINGLE_USER_USED_COUNT_LIMIT"] = "singleUserUsedCountLimit";
})(ActivationCodeStatusType = exports.ActivationCodeStatusType || (exports.ActivationCodeStatusType = {}));
